/* global u */
/**
 * Initializes exhibition page functionality.
 *
 * @param context
 */
const initExhibitionsLanding = function(context) {

  window.cmhr = window.cmhr || {};

  if (typeof context === 'undefined') {
    context = document;
  }


  let exLanding = context.querySelector('.js-exhibition-landing');

  let switchButtons = Array.from(context.querySelectorAll('.js-switch-view'));

  const updateListToggle = function (isNewList) {
    // Need to reset this because the whole section gets replaced when
    // sort by is triggered.

    exLanding = document.querySelector('.js-exhibition-landing');
    const gridButton = document.querySelector('.js-switch-view.link--grid');
    const listButton = document.querySelector('.js-switch-view.link--list');
    //switchButtons = Array.from(document.querySelectorAll(".js-switch-view"));
    
    if (isNewList) {
      if (exLanding) {
        exLanding.classList.add('exhibition-landing--list');
      }
      if (gridButton) {
        gridButton.setAttribute('aria-pressed', 'false');
      }
      if (listButton) {
        listButton.setAttribute('aria-pressed', 'true');
      }
    } else {
      if (exLanding) {
        exLanding.classList.remove("exhibition-landing--list");
      }
      if (gridButton) {
        gridButton.setAttribute("aria-pressed", "true");
      }
      if (listButton) {
        listButton.setAttribute("aria-pressed", "false");
      }
    }
    window.cmhr.viewResultFormat = isNewList ? 'list' : 'grid';
  }

  if (window.cmhr.viewResultFormat) {
    updateListToggle(window.cmhr.viewResultFormat !== 'grid');
  } else {
    window.cmhr.viewResultFormat = switchButtons.length > 0 ? 'grid' : 'list';
  }

  // initiate view toggle
  switchButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        updateListToggle(e.currentTarget.classList.contains('link--list'));
      }
      )
    }
  );
};

export default initExhibitionsLanding;
